import BadgeSquare from '@/components/atoms/BadgeSquare';
import { cn } from '@/utils/tailwind';
import type { MarketInfo } from './market-types';

type MarketInfoCardProps = {
  data: MarketInfo;
  className?: string;
  onClick: (EnName: string, data: MarketInfo) => void;
  component?: React.ReactNode;
};

const MarketInfoCard = (props: MarketInfoCardProps) => {
  const { data, onClick } = props;
  const { MarketIconUrl, MarketName, MarketNameEnglish, IsOrderFurtherActionEnable } = data;

  return (
    <button
      onClick={() => onClick(MarketNameEnglish, data)}
      className={cn(
        'relative flex h-[100px] min-w-[138px] flex-1 flex-col items-center  justify-center gap-[6px] rounded-sm bg-gr-100 py-[16px] transition-colors  duration-200 hover:bg-gr-200 ',
        props.className,
      )}
    >
      {props.component ?? (
        <>
          <img src={MarketIconUrl} alt="마켓 아이콘" className="h-10 w-10" />
          <span className="text-gr-700 Body4S14">{MarketName}</span>
          {IsOrderFurtherActionEnable && (
            <BadgeSquare
              variant={'purple'}
              size="plusBadge"
              className="absolute left-[6px] top-[6px]"
            >
              PLUS
            </BadgeSquare>
          )}
        </>
      )}
    </button>
  );
};

export default MarketInfoCard;
